module.exports = "<h2 class=\"title is-size-4 level-left\">Warehouse Financing</h2>\n    \n\n      \n\n\n"